import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { HubConnection } from '../service/chatHubService.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-chat-users',
  templateUrl: './chat-users.component.html',
  styleUrls: ['./chat-users.component.scss']
})

export class ChatUsersComponent implements OnInit {

  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  userListResponseHolder: any;

  value = '';

  pageModelData = {
    pageIndex: 0,
    pageSize: 500,
    SearchKey:"",
    databaseID: 0,
    organizationID: 0
  };
  pageIndex: any;
  pageSize: any;
  currentDate:any

  peoples: any[] = [];
  DoneButtonShow:boolean=false;
  groupName:string="";
  selectedUser:any[] = [];
  timeout = null;
  users:any[] = [];
  LoggedInEmail:string="";
  chatId:any;
  searchTerm: any="";
  newChatRecivedSubscription: Subscription;
  newGroupCreatedSubscription: Subscription; 
  userRemovedSubscription: Subscription; 
  clickEventsubscription: Subscription; 
  clickEventsubscriptions: Subscription; 
  searchValue: any;
  isEnabled: boolean;
  spinner: boolean;
  loggedinEmail: string;

  constructor(private dialog: MatDialog,private loaderService: LoaderService,
    private ChatsignalRconnaction:HubConnection,private toastr: ToastrService,
    private statusConst: StatusConstant,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.LoggedInEmail=sessionStorage.getItem('email');
      this.currentUser = jwt_decode(token);
     }

     
     
   ngAfterViewInit() {
    this.ChatsignalRconnaction.createHubConnection();
    this.newGroupCreatedSubscription = this.ChatsignalRconnaction.newGroupCreated.subscribe(data => {
    // var currentUser=data.filter((itm) => itm === this.currentUser.UID);
    var currentUser=data.filter((itm) => itm.toLowerCase() === ((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
  );
     if(currentUser?.length >0){
        this.GetAllRoomsforUser();
      }
     });

     this.userRemovedSubscription = this.ChatsignalRconnaction.userRemoved.subscribe(data => {
    // var currentUser=data.userIdLst.filter((itm) => itm === this.currentUser.UID);
    var currentUser=data.userIdLst.filter((itm) => itm.toLowerCase() === ((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
  );
       if(currentUser?.length >0){
        const index = this.users.findIndex((itm) => itm.id === data.groupId);
        if (index >= 0) {
          this.users.splice(index, 1);
        }       
        }
       });

     this.newChatRecivedSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
      if(data!=null){
        if(data.fromUser.email.toLowerCase()!=((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')).toLowerCase()){
          var room = this.users?.find((itm) => itm.id === data.roomId);
          if(room!=null){
            if(room.unReadMessages!=null){
             let index= this.users.findIndex((itm) => itm.id === data.roomId);
             this.users.unshift(this.users.splice(index,1)[0]);
             room.unReadMessages++;
             //room.recentMessage=data.message;
             if(data.message=="" || data.message==undefined){
              room.recentMessage=data.fileName;
            }else{
              room.recentMessage=data.message;
            }
             room.updatedOn=data.createdOn;
            } else{
             room.unReadMessages=1;
             room.recentMessage=data.message;
             room.updatedOn=data.createdOn;
            }      
           }
        }else{
          var room = this.users?.find((itm) => itm.id === data.roomId);
          if(room!=null){
            if(data.message=="" || data.message==undefined){
              room.recentMessage=data.fileName;
            }else{
              room.recentMessage=data.message;
            }
            room.updatedOn=data.createdOn;
             
          }
        }
      }
     });
  }


  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
    this.clickEventsubscriptions.unsubscribe(); 
    this.newGroupCreatedSubscription.unsubscribe(); 
    this.userRemovedSubscription.unsubscribe();
    this.newChatRecivedSubscription.unsubscribe();   
  }

  ngOnInit(): void {
    this.loggedinEmail=((sessionStorage.getItem('email') == null || sessionStorage.getItem('email') == undefined) ? sessionStorage.getItem('portalemail').toLowerCase() : sessionStorage.getItem('email').toLowerCase());
  
    this.clickEventsubscription = this._dataSharingService.getDeleteChatGroup().subscribe((result) => {
      if(result){   
        this.GetAllRoomsforUser();     
        }  
     });
     this.clickEventsubscriptions = this._dataSharingService.getMessageUserOrGroup().subscribe((result) => {
      if(result){
        let index= this.users.findIndex((itm) => itm.id === result);
        this.users.unshift(this.users.splice(index,1)[0]);
        }  
     });
    this.GetAllRoomsforUser(); 
    this.currentDate=new Date();   
  }

  startNewChat(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });
    this.peoples=[];
    this.getPortalEmailUserList(this.pageModelData);
    this.DoneButtonShow=false;
  }

  startNewGroup(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
    });
    this.peoples=[];
    this.getPortalEmailUserList(this.pageModelData);
    this.DoneButtonShow=false;
  }
  
  
  async getUserList(pageData: any) {    
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = pageData.SearchKey.trim();
    this.pageModelData.databaseID = Number(this.databaseId);
    this.pageModelData.organizationID =  Number(this.organizationId);
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if(this.pageModelData.SearchKey!=""){
    const result = await this.ChatsignalRconnaction.GetUsersListForChat(this.pageModelData).toPromise();    
    if(result.data.userModel!=null)
    this.userListResponseHolder = result.data.userModel;
    else
    this.userListResponseHolder=[];
    if (200 === this.statusConst.statusSuccess){
      this.userListResponseHolder.map((res) => {
        if (res.email != null) {
          res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
        }
        if (res.userName != null) {
          res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
        }
        if (res.firstName != null || res.lastName != null) {
          res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.firstName);
          res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.lastName);
          res.name=res.firstName + " "+ res.lastName;
        }       
        return res;
      });
      this.peoples=result.data.userModel.filter((m) => m.uuid != this.currentUser.UID);
      
      this.peoples.forEach(e => {
        e.isChecked=false
       });

       if(this.selectedUser.length>0 && this.peoples.length>0){
        for(var i=0; i< this.selectedUser.length;i++){
          var check=[];
           check=this.peoples.filter(m=> m.uuid==this.selectedUser[i].userId);
           if(check.length>0){
            this.peoples.find((item) => item.uuid == this.selectedUser[i].userId).isChecked = true;
           }
        }

      }
       
      this.pageModelData.pageIndex = result.data.pageIndex;
      this.pageIndex = result.data.pageIndex;
      this.pageSize = pageData.pageSize;    

    } else {
     this.peoples=[];
    }
  }
  else{
    this.peoples=[];
  }
  }

  async getPortalEmailUserList(pageData: any) {
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = pageData.SearchKey.trim();
    this.pageModelData.databaseID = this.databaseId==undefined? 0:Number(this.databaseId);
    this.pageModelData.organizationID =this.organizationId==undefined?0: Number(this.organizationId);
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if(this.pageModelData.SearchKey!=""){
    const result = await this.ChatsignalRconnaction.getPortalEmailUserList(this.pageModelData).toPromise();    
    if(result.data.userModel!=null)
    this.userListResponseHolder = result.data.userModel;
    else
    this.userListResponseHolder=[];
    if (200 === this.statusConst.statusSuccess){
      this.peoples=result.data.userModel;
         
      this.pageModelData.pageIndex = result.data.pageIndex;
      this.pageIndex = result.data.pageIndex;
      this.pageSize = pageData.pageSize;    

    } else {
     this.peoples=[];
    }
  }
  else{
    this.peoples=[];
   }
  }
  
  getShortName(fullName) {
    if(fullName!=undefined)
      {
    var x = fullName.split(' ').splice(0,2).join(' ');
    return x.split(' ').map(n => n[0]).join('');
      }
      return "";
  }

  getShortNameEmail(fullName) {
    var x = fullName.split('@')[0];
    return x;
  }

  SetSearchValue(val){ 
    if(val && val.length>2){
      this.searchValue=val;
      this.isEnabled=true;    
    }
    else{
      this.peoples = [];
      this.searchValue='';
      this.isEnabled=false;
    }       
  }
  
  Search() {
      if(this.searchValue != ''){
      this.spinner=true;
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.pageModelData.SearchKey=this.searchValue.trim();    
        this.getUserList(this.pageModelData);
        this.spinner=false;
      }, 500);
    }else{
      this.peoples=[];     
      this.spinner=false; 
    }
  } 
  SearchEmail() {
    if(this.searchValue!= ''){
    this.spinner=true;
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.pageModelData.SearchKey=this.searchValue.trim();    
      this.getPortalEmailUserList(this.pageModelData);
    }, 500);
  }else{
    this.pageModelData.SearchKey="";    
    this.getPortalEmailUserList(this.pageModelData);
    this.spinner=false;
  }
} 
  close() {
    this.peoples.forEach(e => {      
      e.isChecked=false
     });
    this.selectedUser=[];
    this.groupName="";
    this.pageModelData.SearchKey="";
    this.dialog.closeAll();
    this.searchValue='';
    this.isEnabled=false;
  }

  SelectUser(user){
    let removeIndex = this.selectedUser.findIndex((itm) => itm.userId === user.userId);
    if (removeIndex !== -1) {
      this.selectedUser.splice(removeIndex, 1);   
      this.peoples.forEach(e => {
        if(e.uuid==user.userId) {
          e.isChecked=false
        }
       });     
     }else{          
    }
    if((this.groupName!="" && this.groupName!=undefined && this.groupName!=null)&& this.selectedUser.length > 0){
      this.DoneButtonShow=true;
    }
    else{
      this.DoneButtonShow=false;
    }    
  }

  SelectUserFromCheckBox(event: MatCheckboxChange,user){
    let removeIndex = this.selectedUser.findIndex((itm) => itm.userId === user.uuid);
    if (removeIndex !== -1) {
      this.selectedUser.splice(removeIndex, 1);
      this.peoples.forEach(e => {
        if(e.uuid==user.uuid){
          e.isChecked=false;
        }
       });
     }else{
       var ReqModel={
        userId: user.uuid,
        userName: user.firstName +" "+ user.lastName,
        organizationId: user.organizationId,
        profileImageUrl: user.profileImagePath,
        email: user.email,
       }     
       this.selectedUser.push(ReqModel); 
       this.peoples.forEach(e => {
        if(e.uuid==user.uuid) {
          e.isChecked=true;
        }
        });
      //  if(event.checked==true){
      //     this.peoples.forEach(e => {
      //   if(e.uuid==user.uuid ) {
      //     e.isChecked=true;
      //   }
      //   });
      //  }
     }
    if((this.groupName!="" && this.groupName!=undefined && this.groupName!=null)&& this.selectedUser.length > 0){
      this.DoneButtonShow=true;
    }
    else{
      this.DoneButtonShow=false;
    }
    
  }

  onChange(searchValue: string) {
    if((searchValue!="" && searchValue!=undefined && searchValue!=null)&& this.selectedUser.length > 0){
      this.groupName=searchValue;
      this.DoneButtonShow=true;
    }else{
      this.DoneButtonShow=false;
    }    
  }

  CreateNewGroup() {
    var LoggedIdObj={
      userId: this.currentUser.UID,
      userName: this.currentUser.Name,
      organizationId: Number(this.organizationId),
      profileImageUrl: null,
      email: this.loggedinEmail
     }
    this.selectedUser.push(LoggedIdObj);
    var ReqModel={
      type: "Room",
      roomName: this.groupName,
      organizationId: Number(this.organizationId),
      createdBy: this.currentUser.UID,
      users: this.selectedUser,
      recentMessage:"",
      isOnetoOne:false
    }
    this.close();
    this.ChatsignalRconnaction.CreateChatRoom(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {       
           this.GetAllRoomsforUser();
           this.toastr.success('Group chat created successfully.', '', {
            timeOut: 3000,
           });
          }else{
            this.close();           
          }
         } else {
          this.close();          
        }
      });
  }
  
  CreateNewChat(user) {
    var LoggedIdObj={
      userId: user.uuid,//this.currentUser.UID,
      userName:this.getShortNameEmail(((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
    ), //this.currentUser.Name,
      organizationId: this.organizationId==undefined? 0:Number(this.organizationId),
      profileImageUrl: null,
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
   
     }
     this.selectedUser.push(LoggedIdObj);
     var req={
      userId: user.uuid,
      userName:this.getShortNameEmail(user.email)
    ,//user.firstName +" "+ user.lastName,
      organizationId: user.organizationId,
      profileImageUrl:"", //user.profileImagePath,
      email: user.email   
     }
    this.selectedUser.push(req);
    var ReqModel={
      type: "Room",
      roomName: "",
      organizationId: Number(this.organizationId),
      createdBy: this.currentUser.UID,
      users: this.selectedUser,
      recentMessage:"",
      isOnetoOne:true,
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
    }
   // return;
    this.close();
    this.ChatsignalRconnaction.CreateChatRoom(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
           var data=this.responseHolder.data;
           if(data.users!=null){
            var checkdata=this.users.filter((itm) => itm.id === this.responseHolder.data.id);
            var firstData=checkdata[0];
             this.chatId=firstData.id;
             this._dataSharingService.sendSelectedChatParticipant(firstData);
           }else{
            this.GetAllRoomsforUser();
            this.toastr.success('Chat created successfully.', '', {
             timeOut: 3000,
            });
           } 
          }else{
            this.close();            
          }
         } else {
          this.close();          
        }
      });
  }


  GetAllRoomsforUser() {
    var ReqModel={
     // userId:this.currentUser.UID
     email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
    }
    this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.users=response.data;
         if(this.users.length>0){
          var firstData=this.users[0];
          this.chatId=firstData.id;
          this.users=response.data;        
          this._dataSharingService.sendSelectedChatParticipant(firstData);
          }
          }else{
            this.users=[];     
          }
         } else {
          this.users=[];        
        }
      });
  }

  GetAllRoomsforUserSearchClear() {
    var ReqModel={
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
    }
    this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.users=response.data;        
          }else{
            this.users=[];            
          }
         } else {
          this.users=[];         
        }
      });
  }

  fillResult(user:any,array:any){
  if(user==undefined){
    user=[];
   }
  if(array.length>0){
   array.forEach(e => {
    user.push(e);
   });
  }
  return user;
  }


  SearchChatOrMessages() {  
    if(this.searchTerm != ''){
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.findChatOrMessages();
    }, 600);
    }else{
    this.findChatOrMessages();
    }
  } 
  
  findChatOrMessages() {
    if(this.searchTerm.replace(/\s/g, "").toLowerCase()=="") {  
      this.GetAllRoomsforUserSearchClear();
      return ;
    }
    var ReqModel={
      searchTerm:this.searchTerm,
      userId: this.currentUser.UID,
      email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')),
      pageIndex: 0,
      pageSize: 0     
    }   
    this.ChatsignalRconnaction.SearchChatOrMessages(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.users=[];

         this.users=this.fillResult(this.users,response.data.chatMessages);
         this.users=this.fillResult(this.users,response.data.chatRoomsWithMatchNames);
         this.users=this.fillResult(this.users,response.data.chatRoomsWithMatchedUser);        
       
         this.users= this.users.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);       

          }else{
            this.users=[];;
          }
         } else {
          this.users=[];
        }
      });
  }

  chatDetails(users){
    this._dataSharingService.sendNewChatMessageCountUpdate(true);
    users.unReadMessages=0;
    this.chatId=users.id;
    this._dataSharingService.sendSelectedChatParticipant(users);
    this._dataSharingService.sendAddAttachmentFile(false);
  }


  
}
